@switch (columnName) {
  @case ('length') {
    {{ form.dimension.length.value + ' ' }}
    {{ dimensionUnit[form.dimension.dimensionsUnit.value] | translate }}
  }
  @case ('breadth') {
    {{ form.dimension.breadth.value + ' ' }}
    {{ dimensionUnit[form.dimension.dimensionsUnit.value] | translate }}
  }
  @case ('depth') {
    {{ form.dimension.depth.value + ' ' }}
    {{ dimensionUnit[form.dimension.dimensionsUnit.value] | translate }}
  }
  @case ('volume') {
    {{ form.volume.value + ' ' }}
    {{ 'tonnes' | translate }}
  }
  @case ('edit') {
    @if (!hideButtons) {
      <app-ui-button
        buttonType="icon-button"
        icon="edit"
        [ariaLabel]="'edit' | translate"
        (click)="buttonFunctions.edit()"
      ></app-ui-button>
    }
  }
  @case ('delete') {
    @if (!hideButtons) {
      <app-ui-button
        buttonType="icon-button"
        icon="delete"
        [ariaLabel]="'delete' | translate"
        (click)="buttonFunctions.delete()"
      ></app-ui-button>
    }
  }
  @default {
    {{ form.get(columnName)?.value }}
  }
}
